import { faIdCard } from '@fortawesome/pro-light-svg-icons';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Quotation } from 'data-layer-cr/dist/models';
import { dateFormat } from 'design-system';
import { useMemo } from 'react';
import genderString from 'src/functions/genderString';
import InformationCardLayout from './InformationCardLayout';
import InformationRow from './InformationRow';

const { dateFromServerString } = dateFormat;

const useStyle = makeStyles(() => ({
  subtitleContainer: {
    textTransform: 'capitalize',
    marginTop: 20,
    fontWeight: 900,
    fontSize: 17,
  },
}));

type Props = {
  quotation: Quotation;
};

const DriverInformationCard = ({ quotation }: Props): JSX.Element => {
  const classes = useStyle();

  const driver = useMemo(() => quotation.units[0].unit.driver, [quotation]);

  return (
    <InformationCardLayout
      data-testid="driver-information-card"
      icon={faIdCard}
      title="Datos del conductor"
    >
      <Grid item xs={12}>
        <Typography
          data-testid="driver-name"
          className={classes.subtitleContainer}
        >
          {`${driver.firstName} ${driver.lastName}`}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <InformationRow
          data-testid="birthday-row"
          description="Fecha de nacimiento"
          value={dateFromServerString(driver.birthday)}
        />
      </Grid>
      <Grid item xs={12}>
        <InformationRow
          data-testid="gender-row"
          description="Género"
          value={genderString(driver.gender)}
        />
      </Grid>
    </InformationCardLayout>
  );
};

export default DriverInformationCard;
